import { AuthProvider } from './context/Auth/AuthProvider';
import AppRoutes from './routes/appRoutes';

const App: React.FC = () => {
  return (
    <AuthProvider>
        <AppRoutes />
    </AuthProvider>
  );
};

export default App;
